export class AcceptGdpr {
    static readonly type = '[GDPR] Accept';
}
